import React from 'react'

const Pagenation = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
	const totalPages = Math.ceil(totalItems / itemsPerPage)
	const maxPageNumbers = 5

	const getPageNumbers = () => {
		const pageNumbers = []
		let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbers / 2))
		let endPage = Math.min(totalPages, startPage + maxPageNumbers - 1)

		if (endPage - startPage + 1 < maxPageNumbers) {
			startPage = Math.max(1, endPage - maxPageNumbers + 1)
		}

		for (let i = startPage; i <= endPage; i++) {
			pageNumbers.push(i)
		}

		return pageNumbers
	}

	if (totalPages <= 1) return null

	return (
		<div>
			<div className='pagination-container mt-3 mb-3'>
				<ul className='pagination pagination-dark justify-content-end'>
					<li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
						<a className='page-link' href='#' aria-label='Previous' onClick={() => onPageChange(currentPage - 1)}>
							<span aria-hidden='true'>
								<span className='material-icons'>arrow_back</span>
							</span>
						</a>
					</li>
					{getPageNumbers().map((pageNumber) => (
						<li key={pageNumber} className={`page-item ${pageNumber === currentPage ? 'active' : ''}`}>
							<a className='page-link' href='#' onClick={() => onPageChange(pageNumber)}>
								{pageNumber}
							</a>
						</li>
					))}
					<li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
						<a className='page-link' href='#' aria-label='Next' onClick={() => onPageChange(currentPage + 1)}>
							<span aria-hidden='true'>
								<span className='material-icons'>arrow_forward</span>
							</span>
						</a>
					</li>
				</ul>
			</div>
		</div>
	)
}

export default Pagenation
